window.REBASE = window.REBASE || {};
REBASE.theme = {};

(function($) {

  var PRODUCT_IMG_THRESHOLD = 23;
  var PRODUCT_IMAGES = $('#product__images').length ? JSON.parse($('#product__images').html()) : null;
  
  var _appendToFilename = function(filename, str) {
    var dot_indx = filename.lastIndexOf('.');

    if (dot_indx === -1) {
      return filename + str;
    } else {
      return filename.substring(0, dot_indx) + str + filename.substring(dot_indx);
    }
  };

  var setActiveThumbnail = function(target) {
    var THUMB_ACTIVE_CLASS = 'gallery__thumbnail-wrapper--active';

    if (!target.hasClass(THUMB_ACTIVE_CLASS) && target.hasClass('gallery__thumbnail-wrapper')) {
      target.addClass(THUMB_ACTIVE_CLASS).siblings().removeClass(THUMB_ACTIVE_CLASS);
    }
  };

  var setActivePagination = function(target) {
    var PAGINATION_ACTIVE_CLASS = 'gallery__pagination-item--active';

    if (!target.hasClass(PAGINATION_ACTIVE_CLASS) && target.hasClass('gallery__pagination-item')) {
      target.addClass(PAGINATION_ACTIVE_CLASS).siblings().removeClass(PAGINATION_ACTIVE_CLASS);
    }
  };

  var _buildProductPhotoGallery = function(specific_sku, include_thumbnails) {

    var imgs_html = '',
      thumb_html = '',
      pagingation_html = '',
      gallery_height,
      preloaded_img,
      product_imgs = PRODUCT_IMAGES;

    if (specific_sku) {
      
      product_imgs = product_imgs.filter(function(img) {
        return (img.url.includes('_' + specific_sku + '_') || img.url.includes('_0' + specific_sku + '_') || (img.url.includes('info') || img.url.includes('lifestyle')));
      });
    }
console.log(product_imgs)
    product_imgs.map(function(img, indx) {
      var img_2048 = _appendToFilename(img.url, '_2048x'),
        img_500 = _appendToFilename(img.url, '_500x'),
        img_1600 = _appendToFilename(img.url, '_1600x');

      imgs_html += '<figure data-reswiper-slide-index="' + indx + '" class="reswiper-slide"><a href="' + img_2048 + '" data-size="' + img.ratio + '"><img alt="' + img.alt + '" src="' + img_500 + '" srcset="' + img_500 + ' 1x, ' + img_1600 + ' 2x"></a></figure>'
    });

    var img_file_120;

    if (include_thumbnails) {
      product_imgs.map(function(img, indx) {
        img_file_120 = $('<img/>');
        img_file_120.src = _appendToFilename(img.url, '_120x');
        img_file_60 = $('<img/>');
        img_file_60.src = _appendToFilename(img.url, '_60x');

        var img_60 = _appendToFilename(img.url, '_60x'),
          img_120 = _appendToFilename(img.url, '_120x');

        thumb_html += '<a href="#" role="presentation" class="gallery__thumbnail-wrapper" data-image-index="' + indx + '"><img class="gallery__thumbnail" alt="' + img.alt + '" src="' + img_120 + '" srcset="' + img_120 + ' 1x, ' + img_120 + ' 2x"></a>';
      });
    } else {
      product_imgs.map( (img, i) => {
        pagingation_html += `<a href="#" class="gallery__pagination-item" data-image-index="${i}">Image</a>`;
      });
    }

    // unbind old thumbs if they exist
    $('.gallery__thumbnail-wrapper').off('click.rbProduct');
    // replace thumb html
    $('.gallery__thumbnails').html(thumb_html);
    $('.gallery__pagination').html(pagingation_html);


    if (REBASE.theme.product_photo_gallery) {
      gallery_height = $('#product-images').outerHeight();
      $('#product-images').css('height', gallery_height);

      REBASE.theme.product_photo_gallery.destroy();
      $('.reswiper-wrapper .reswiper-slide').remove();
      preloaded_img = $('<img/>');
      preloaded_img[0].src = _appendToFilename(product_imgs[0].url, '_1200x');
    }

    $('.reswiper-wrapper').prepend(imgs_html);
    if (preloaded_img) {
      preloaded_img.on('load', function() {
        $('#product-images').css('height', 'auto');
      });
    }

    REBASE.theme.product_photo_gallery = new Reswiper('.reswiper-container', {
      loop: false,
      effect: 'slide',
      speed: 250,
      navigation: {
        nextEl: '.reswiper-container .reswiper-button-next',
        prevEl: '.reswiper-container .reswiper-button-prev'
      },
      pagination: {
        el: '.reswiper-container .reswiper-pagination',
        type: 'bullets'
      },
      on: {
        slideChange: function() {
          // NOTE: runs even if no thumbnails exist, but thats fine
          setActiveThumbnail($('.gallery__thumbnail-wrapper[data-image-index="' + REBASE.theme.product_photo_gallery.activeIndex + '"]'));
          setActivePagination($('.gallery__pagination-item[data-image-index="' + REBASE.theme.product_photo_gallery.activeIndex + '"]'));
        }
      }
    });


    if (include_thumbnails) {

      // set inital slide to active
      setActiveThumbnail($('.gallery__thumbnail-wrapper[data-image-index="0"]'));

      $('.gallery__thumbnail-wrapper').on('click.rbProduct', function(e) {
        var target = $(e.target),
          img_indx;

        e.preventDefault();

        if (target.hasClass('gallery__thumbnail')) {
          target = target.parent('.gallery__thumbnail-wrapper');
        }
        target.addClass('gallery__thumbnail-wrapper--active').siblings().removeClass('gallery__thumbnail-wrapper--active');
        setActiveThumbnail(target);
        img_indx = target.data('image-index');
        REBASE.theme.product_photo_gallery.slideTo(img_indx);
      });
      $('.reswiper-button-next, .reswiper-button-prev, .gallery__thumbnails').removeClass('hidden');

    } else {
      $('.reswiper-button-next, .reswiper-button-prev, .gallery__thumbnails').addClass('hidden');
      setActivePagination($('.gallery__pagination-item[data-image-index="0"]'));

      $('.gallery__pagination').on('click', '.gallery__pagination-item', e => {
        e.preventDefault();
        var target = $(e.target);
        var img_index = e.target.dataset.imageIndex;
        var pagination = target.parent('.gallery__pagination');
        target.addClass('gallery__pagination-item--active').siblings().removeClass('gallery__pagination-item--active');
        setActiveThumbnail(pagination);
        REBASE.theme.product_photo_gallery.slideTo(img_index);
      });
    }

  };



  /*
   * ----------------------------------------
   * Main script
   * ----------------------------------------
   */
  $(function() {

    // Initiate CSS animations
    AOS.init();

    // Setting Up Global Variables to be used in JS - Denotes which template is which so JavaScript is used only on proper templates
    var BODY = $('body'),
      IS_INDEX = (BODY.hasClass('index-template')) ? true : false,
      IS_COLLECTION = (BODY.hasClass('collection-template')) ? true : false,
      IS_COLLECTION_LISTING = (BODY.hasClass('list-collections-template')) ? true : false,
      IS_PRODUCT = (BODY.hasClass('product-template')) ? true : false,
      IS_BLOG = (BODY.hasClass('blog-template')) ? true : false,
      IS_ARTICLE = (BODY.hasClass('article-template')) ? true : false,
      IS_SEARCH = (BODY.hasClass('search-template')) ? true : false,
      IS_PAGE = (BODY.hasClass('rb__page-template')) ? true : false,
      IS_CART = (BODY.hasClass('cart-template')) ? true : false,
      HAS_PRODUCTS = ($('.product').length > 0) ? true : false;

    if (HAS_PRODUCTS) {
      function preloadImg(src) {
        $('<img/>')[0].src = src;
      }

      // collection swatches
      $('.product').hover(function() {
        $('.product-swatch').each(function() {
          preloadImg($(this).data('variant-image'));
        });
      });

      // collection product swatches image swap
      $('.product-swatch').on('click', function() {
        var featured_image = '#product__image--' + $(this).data('prod-id'),
          qv_btn = '.product__quickview--' + $(this).data('prod-id'),
          main_prod = '.product--' + $(this).data('prod-id'),
          variant_image = $(this).data('variant-image'),
          variant_id = $(this).data('variant-id'),
          prod_price = '.product__price--' + $(this).data('prod-id'),
          prod_compare_price = '.product__old-price--' + $(this).data('prod-id'),
          variant_price = $(this).data('variant-price'),
          variant_compare_price = $(this).data('variant-compare-price'),
          default_image = $(featured_image).data('default-image'),
          default_image = $(main_prod).data('default-price'),
          savings = $(this).data('savings');

        // if ($(this).hasClass('product-swatch--selected')) {
        //   $(this).removeClass('product-swatch--selected');
        //   $(featured_image).attr('src', default_image);
        //   $(main_prod).removeClass('product--on-sale');
        //   $('.product__sale', main_prod).remove();
        //   $('.product__old-price', main_prod).remove();
        // }
        // else {
          $(this).addClass('product-swatch--selected').siblings().removeClass('product-swatch--selected');
          $(qv_btn).attr('data-active-variant', variant_id);
          $(featured_image).attr('src', variant_image);
          $(prod_price).html(variant_price);

          if (variant_compare_price > variant_price) {
            $(main_prod).addClass('product--on-sale');
            $('.product__meta--pricing', main_prod).append('<span class="product__old-price"><span class="old-price-was">was</span> <span class="old-price old-price">'+ variant_compare_price +'</span></span>')
            $('.product__badges', main_prod).html('<span class="product__sale">Save '+ savings +'%</span>');
          }
          else {
            $(main_prod).removeClass('product--on-sale');
            $('.product__sale', main_prod).remove();
            $('.product__old-price', main_prod).remove();
          }
        // }
      });
    }

    // Mobile Navigation
    var mmStatus = 'closed';

    function closeMM() {
      mmStatus = 'closed';
      $('#mobile-navigation-toggle').toggleClass('opened');
      $('body').removeClass('nav-opened');
    }

    function openMM() {
      mmStatus = 'opened';
      $('body').addClass('nav-opened');
      $('#mobile-navigation-toggle').toggleClass('opened');
    }

    $('#mobile-navigation-toggle').on('click', function() {
      if (mmStatus == 'closed') {
        openMM();
      } else if (mmStatus == 'opened') {
        closeMM();
      }
      return false;
    });
    $('.mobile-dropdown-toggle').on('click', function() {
      $('.fa', this).toggleClass('fa-plus fa-times');
      $(this).next().toggle();
    });

    function showDD() {
      $(this).siblings().removeClass('hovered');
      $(this).toggleClass('hovered');
      $(this).attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true'
      });
    }

    function hideDD() {
      if ($(this).hasClass('stay')) {
        $(this).siblings().removeClass('hovered');
        $(this).siblings().attr('aria-expanded', false);
      } else {
        $(this).removeClass('hovered');
        $(this).attr('aria-expanded', false);
      }
    }
    /* main navigation */
    $(".rb__navigation-li").hoverIntent({
      timeout: 0,
      over: showDD,
      out: hideDD
    });

    $('.rb__navigation-main-link--shop').on('click', function() {
      $(this).parent().addClass('hovered stay');
      return false;
    });

    $('#search-link-a').on('click', function(e){
      e.preventDefault();
      if (!$('body').hasClass("search-bar-opened")){
        $('body').addClass("search-bar-opened");
        setTimeout(function() { $('.search-dropdown__input').focus() }, 800);
      } else {
        $('body').removeClass("search-bar-opened");
      }
    });

    $.getJSON('https://ipinfo.io', function(data) {
      if (data.country == 'CA') {

      }
    });

    // focus on cart open
    $('.minicart-toggle-btn').on('click', function() {
      setTimeout(function() { $('.minicart__actions .btn').focus() }, 800);
    });

    // =================================
    //  Product Page - Quantity buttons, Tabs, Reviews, Image Gallery, Options Selects, Swatches
    // =================================
    if (IS_PRODUCT) {
      REBASE.theme.bindProductControls();
    }
  });


  /*
   * ----------------------------------------
   * Setup Product page controls (needs to run on product pages and when quickview is opened)
   * ----------------------------------------
   */
  REBASE.theme.appendToFilename = function(filename, str) {
    var dot_indx = filename.lastIndexOf('.');

    if (dot_indx === -1) {
      // eslint-disable-line no-magic-numbers
      return filename + str;
    } else {
      return filename.substring(0, dot_indx) + str + filename.substring(dot_indx);
    }
  };

  REBASE.theme.unbindProductControls = function() {
    $('#product-qty-input, #product-rating, #product-content-sections, .gallery__thumbnail-wrapper').off('.rbProduct');
    $('#upsell-products-toggle, .upsell-product, #product-qty-input, #product-rating, #product-content-sections').off('.rbProduct');
  };

  REBASE.theme.bindProductControls = function() {
    // Using the old fashioned way of creating an event instead of
    // the `new Event()` constructor method to support back to IE11
    var bindProductControlsEvent = document.createEvent('Event');
    bindProductControlsEvent.initEvent('REBASE:bindProductControls', true, true);
    document.dispatchEvent(bindProductControlsEvent);

    var product,
      is_video = $('#product-video-player').length > 0;


    $('#upsell-products-toggle').on('click.rbProduct', function(e) {
      var _this = $(this);
      e.preventDefault();
      $('.upsell-products-list').stop().toggle();

      if (_this.hasClass('open')) {
        _this.html('<i class="fa fa-times-rectangle"></i> Hide Available Accessories');
        _this.removeClass('open');
      } else {
        _this.html('<i class="fa fa-plus-square"></i> View Available Accessories');
        _this.addClass('open');
      }
    });

    $('.add-item-section__toggle--extra').on('click.rbProduct', function(e) {
      e.preventDefault();
      $('.fa', this).toggleClass('fa-square-o fa-check-square');
      $(this)
        .toggleClass('add-item-section__toggle--active')
        .parent()
        .toggleClass('extra-product--selected');

      if (typeof calculateExtraPrice === 'function') {
        calculateExtraPrice();
      }
    });

    // Quantity buttons
    $('.qtyplus, .qtyminus').show();
    $('#product-qty-input').on('click.rbProduct', '.qtyplus, .qtyminus', function(e) {
      var quantity_input = $('#quantity'),
        quant_val = parseInt(quantity_input.val());
      e.preventDefault();

      if ($(e.target).hasClass('qtyplus')) {
        if (!quant_val) { quant_val = 0; }
        quant_val += 1;
      } else {
        if (!quant_val) { quant_val = 1; }
        if (quant_val > 1) { quant_val -= 1; }
      }

      quantity_input.val(quant_val);
    });

    // // Product Reviews
    //   $('#product-rating').on('click.rbProduct', function (e) {
    //       var modal_parent = $(e.target).parents('.modal__content-wrapper');

    //       $('.product-content-section-title--reviews').trigger('click');

    //       if (modal_parent.length) {
    //           modal_parent.animate({scrollTop: $('#product-reviews').offset().top - 54}, 500);
    //       } else {
    //           $('html, body').animate({scrollTop: $('#product-reviews').offset().top - 54}, 500);
    //       }

    //   });

    // Product Sections
    $('#product-content-sections').on('click.rbProduct', '.product-content-section-title h3', function(e) {
      var ACTIVE_TITLE_CLASS = 'product-content-section-title--active',
        ACTIVE_SECTION_CLASS = 'product-content-section--active',
        selected_tab_id = $(e.target).data('tab-id'),
        selected_section = $(selected_tab_id),
        modal_parent = $(e.target).parents('.modal__content-wrapper'),
        should_close = false;


      if ($('.product-content-section-title h3[data-tab-id="' + selected_tab_id + '"]').parent().hasClass(ACTIVE_TITLE_CLASS)) {
        should_close = true;
      }

      // Remove existing active classes
      $('.' + ACTIVE_TITLE_CLASS).removeClass(ACTIVE_TITLE_CLASS);
      $('.' + ACTIVE_SECTION_CLASS).removeClass(ACTIVE_SECTION_CLASS);

      if (!should_close) {
        // Select new tab & section
        $('.product-content-section-title h3[data-tab-id="' + selected_tab_id + '"]').parent().addClass(ACTIVE_TITLE_CLASS);
        selected_section.addClass(ACTIVE_SECTION_CLASS);

        // Scroll to content
        if (modal_parent.length) {
          modal_parent.animate({ scrollTop: modal_parent.scrollTop() + selected_section.position().top - 88 }, 500);
        } else {
          $('html, body').animate({ scrollTop: selected_section.offset().top - 88 }, 500);
        }
      }
    });

    // Image Galleries
    if ($('.reswiper-container').length && PRODUCT_IMAGES && PRODUCT_IMAGES.length) {

      $('.reswiper-container').append('<div class="reswiper-pagination reswiper-pagination-black"></div><div class="reswiper-button-prev reswiper-button-white"></div><div class="reswiper-button-next reswiper-button-white"></div>');

      if (PRODUCT_IMAGES.length < PRODUCT_IMG_THRESHOLD) {
        _buildProductPhotoGallery();
      } else {
        // NOTE: do nothing - variant selection will generate it
      }
    }

    // Sliders on mobile for upsells and swatches
    let swatchSwiper;
    let upsellSwiper;
    function initSliders() {
      const swatches = document.querySelector('.swatches');
      if (swatches) {
        swatchSwiper = new Flickity(swatches, {
          contain: true,
          cellAlign: 'left',
          freeScroll: true,
          pageDots: false,
          prevNextButtons: false,
          on: {
            ready: function() {
              const slideContainer = this.element.querySelector('.flickity-slider');
              setTimeout(() => { slideContainer.style.transform = 'translateX(0)';}, 1000);
            }
          }
        });
      }

      const productUpsells = document.querySelector('#upsell-products .upsell-products-list');
      if (productUpsells) {
        upsellSwiper = new Flickity(productUpsells, {
          contain: true,
          cellAlign: 'left',
          pageDots: false,
          prevNextButtons: false,
          on: {
            ready: function() {
              const slideContainer = this.element.querySelector('.flickity-slider');
              setTimeout(() => { slideContainer.style.transform = 'translateX(0)';}, 1000);
            }
          }
        });
      }
    }

    let pageWidth = window.innerWidth;
    let resizeTimer;

    if(pageWidth < 740){
      initSliders();
    }

    $(window).on('resize', function(e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        pageWidth = window.innerHeight;
        if(pageWidth < 958){
          initSliders();
        } else {
          if(swatchSwiper.options){
            swatchSwiper.destroy();
          }
          if(upsellSwiper.options){
            upsellSwiper.destroy();
          }
        } 
      }, 250);
    });
   


    // Option Selectors & Swatches
    // NOTE: must come after image gallery (for selected variant to show correct image when loading page)
    product = new REBASE.theme.Product({
      $container: $('#add-item-form')
    });
  };


  /*
   * ----------------------------------------
   * Product class
   * ----------------------------------------
   */
  REBASE.theme.Product = (function() {
    function Product(options) {
      var inputs,
        input_type;

      this.variants = null;
      this.$container = options.$container;
      this.data = JSON.parse(document.getElementById('product__json').innerHTML);

      this.settings = {
        single_option_selector: '.single-option-select',
        original_select_id: 'select#product-select'
      };


      if (this.data) {
        this._initVariants();

        // Trigger change to sync up images, etc on initial page load
        inputs = $(this.settings.single_option_selector, this.$container);
        input_type = inputs.first().attr('type');

        if (input_type === 'radio' || input_type === 'checkbox') {
          inputs.filter(':checked:first').trigger('change');
        } else {
          inputs.first().trigger('change');
        }
      } else {
        if (console) { console.log('Missing product json data!'); }
      }
    }

    Product.prototype = $.extend({}, Product.prototype, {

      _initVariants: function() {
        var options = {
          $container: this.$container,
          enable_history_state: true,
          single_option_selector: this.settings.single_option_selector,
          original_select_id: this.settings.original_select_id,
          product: this.data
        };

        this.variants = new REBASE.theme.Variants(options);

        this.$container.on('variantChange', this._updateAddToCart.bind(this));
        this.$container.on('variantImageChange', this._updateImages.bind(this));
        this.$container.on('variantPriceChange', this._updatePrice.bind(this));
        this.$container.on('variantSKUChange', this._updateSKU.bind(this));
      },

      _updateAddToCart: function(e) {
        var variant = e.variant,
          all_variants_match_option1 = e.all_variants_match_option1,
          target = $(e.target),
          input_type = target.attr('type'),
          add_to_cart_btn = $('#add-to-cart'),
          btn_txt = $('#add-to-cart-text'),
          btn_txt_value = btn_txt.data('add-to-cart-text');

          if (!variant) {
          add_to_cart_btn.addClass('disabled').attr('disabled', 'disabled');
          btn_txt.text('Not Available');
          $('#product-pricing-wrapper .product-price').html('<span>Not Available</span>');
          $('#product-pricing-wrapper .old-price').empty();
        } else {
          if (variant.available) {
            add_to_cart_btn.removeClass('disabled').removeAttr('disabled');
            btn_txt.text(btn_txt_value);
          } else {
            add_to_cart_btn.addClass('disabled').attr('disabled', 'disabled');
            btn_txt.text('Sold Out');
          }
        }

        if (input_type === 'radio' || input_type === 'checkbox') {
          target.parent('.swatch-element').addClass('selected-swatch').siblings().removeClass('selected-swatch');

          // MODDED FOR SWATCH AVAILABILITY (only one level deep, option2)
          var option2_inputs = $('input[data-index="option2"]'),
            option2_vals = option2_inputs.map(function() { return $(this).val(); }).get(),
            option2_not_available = $.map(option2_vals, function(option_val) {
              var is_available = false;

              $.each(all_variants_match_option1, function(i, match_variant) {
                if (match_variant.option2 === option_val) {
                  if (match_variant.available) { is_available = true; }
                }
              });


              if (is_available) {
                return undefined;
              } else {
                return option_val;
              }
            });

          option2_inputs.parent('.swatch-element').removeClass('swatch-unavailable');


          $.each(option2_not_available, function(indx, option_val) {
            option2_inputs.each(function() {
              var current_option_input = $(this);

              if (current_option_input.val() === option_val) {
                current_option_input.parent('.swatch-element').addClass('swatch-unavailable');
              }
            });
          });
        }


        if (PRODUCT_IMAGES.length && PRODUCT_IMAGES.length < PRODUCT_IMG_THRESHOLD && REBASE.theme.product_photo_gallery) {

          var found_indx = PRODUCT_IMAGES.findIndex(function(img) {
            // NOTE: ensuring string comparison
            return img.variant_id + '' === variant.id + '';
          });

          if (found_indx > -1) {
            REBASE.theme.product_photo_gallery.slideTo(found_indx);
          }

        }

        // sets an upsell product varaint to parent product color if it finds a match
        $('.extra-single-option-select').each(function(index, el){
          if ($(el).find('option[value="'+ variant.option1 +'"]').length) {
            $(el).val(variant.option1).trigger('change');
          }
        });

      },
      _updateImages: function(e) {},
      _updatePrice: function(e) {
        var variant = e.variant,
          main_price = $('.product-price'),
          old_price = $('.product-compare-price'),
          compare_price = variant.compare_at_price;

        main_price.html(Shopify.formatMoney(variant.price, Shopify.money_format).replace('.00', ''));

        if (compare_price && compare_price > variant.price) {
          main_price.addClass('product-price--sale');
          $('.product-compare-price-amount', old_price).html(Shopify.formatMoney(compare_price, Shopify.money_format).replace('.00', ''));
          old_price.show();
        } else {
          main_price.removeClass('product-price--sale');
          $('.product-compare-price-amount', old_price).empty();
          old_price.hide();
        }


      },
      _updateSKU: function(e) {
        // $('#product-sku .product-meta-item-content').text(e.variant.sku);
        if (PRODUCT_IMAGES && PRODUCT_IMAGES.length >= PRODUCT_IMG_THRESHOLD) {
          _buildProductPhotoGallery(e.variant.sku, false);
        }
      }
    });

    return Product;
  })();


  /*
   * ----------------------------------------
   * Product Variants class - based on Shopify debut
   * ----------------------------------------
   */
  REBASE.theme.Variants = (function() {

    function Variants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.single_option_selector = options.single_option_selector;
      this.original_select_id = options.original_select_id;
      this.enable_history_state = options.enable_history_state;
      this.current_variant = {};

      $(this.single_option_selector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

      /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @return {array} options - Values of currently selected variants
       */
      _getCurrentOptions: function() {
        var should_filter = false,
          the_options = $.map($(this.single_option_selector, this.$container), function(element) {
            var $element = $(element),
              type = $element.attr('type'),
              current_option = {};


            if (type === 'radio' || type === 'checkbox') {
              should_filter = true;

              if ($element[0].checked) {
                current_option.value = $element.val();
                current_option.index = $element.data('index');
                return current_option;
              } else {
                return false;
              }
            } else {
              current_option.value = $element.val();
              current_option.index = $element.data('index');
              return current_option;
            }
          });

        // Remove any unchecked input values if using radio buttons or checkboxes
        // Removes all falsy values (Boolean constructor is a function, if the value is omitted or is 0, -0, null, false, NaN, undefined, or the empty string ("") then it will get removed)
        if (should_filter) {
          the_options = the_options.filter(Boolean);
        }

        return the_options;
      },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = variants.filter( function(variant) {
        return selectedValues.every(function(values) {
          return variant[values.index] == values.value;
        });
      });

      return found[0];
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function(e) {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
        target: e.target
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.current_variant = variant;

      if (this.enable_history_state) {
        this._updateHistoryState(variant);
      }
    },

      /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
      _updateImages: function(variant) {
        var variant_image = variant.featured_image || {},
          current_variant_image = this.current_variant.featured_image || {};

        if (!variant.featured_image || variant_image.src === current_variant_image.src) {
          return;
        }

        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },

      /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
      _updatePrice: function(variant) {

        if (variant.price === this.current_variant.price && variant.compare_at_price === this.current_variant.compare_at_price) {
          return;
        }

        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },

      /**
       * Trigger event when variant sku changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantSKUChange
       */
      _updateSKU: function(variant) {
        if (variant.sku === this.current_variant.sku) {
          return;
        }
        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },

      /**
       * Update history state for product deeplinking
       *
       * @param  {variant} variant - Currently selected variant
       * @return {k}         [description]
       */
      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {return;}

        var searchParams = new URLSearchParams(window.location.search);
        var newurl;

        searchParams.set('variant', variant.id);
        newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.toString();
        window.history.replaceState({path: newurl}, '', newurl);
      },
      
      /**
       * Update hidden master select of variant change
       *
       * @param  {variant} variant - Currently selected variant
       */
      _updateMasterSelect: function(variant) {
        $(this.original_select_id, this.$container).val(variant.id);
      }
    });

    return Variants;
  })();

})(jQuery);

